import React, { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./../MainHeader.module.scss";
import SlidingWidget, {CaptionButton, SlidingWidgetFooter} from "./SlidingWidget"
import { SearchWidget, TreeList, InlineLoader } from "@netapp/bxp-design-system-react"
import serviceConnectorMenuStyles from "./ConnectorMenu.module.scss";
import _ from "lodash";
import { DropdownArrowDownIcon, DropdownArrowUpIcon } from "@netapp/bxp-style/react-icons/Navigation"
import { IAMResourceIconRenderer } from "../../../../components/common";
import { useLocation } from 'react-router-dom';
import { recursiveSearch } from "modules/identity-access-management/utils";
import { useTranslation } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";
import { useFeatureFlag } from "../../../../utils/useFeatureFlag";

// Paths where the scope menu shows "All" instead of the active scope name
const SHOW_ALL_SCOPE_LOCATIONS = ['/identity-access-mgmt', '/home'];
// Paths where the scope menu should be disabled (superset of SHOW_ALL_SCOPE_LOCATIONS)
const DISABLED_LOCATIONS = [...SHOW_ALL_SCOPE_LOCATIONS, '/fleets/'];

const ScopeMenuFooter = ({activeScope, selectedScope}) => {
    const dispatch = useDispatch();

    return <SlidingWidgetFooter onSwitch={() => {
        if(activeScope === selectedScope){
            return;
        }

        dispatch({
            type: "TENANCYV4:SET-SCOPE",
            payload: {
                scopeId: selectedScope.id
            },
            track: true
        });

        dispatch({
            type: "MENU:CLOSE-WIDGET"
        })
    }} onClose={() => {
        dispatch({
            type: "MENU:CLOSE-WIDGET"
        })
    }}/>
};



const MenuContent = React.memo(({setSelectedScope}) => {
    const activeScope = useSelector(state => state.tenancy.selectedScope);
    const orgs = [useSelector(state => state.tenancy.selectedOrg)] || [];
    const [activeFilter, setActiveFilter] = useState("");
    const { t } = useTranslation(i18nNamespace);
    const isFleetManagementEnabled = useFeatureFlag("NetApp.FleetManagement/*");

    const filteredScopes = useMemo(() => {
        if(activeFilter) {
            let selectedOgranizationData = _.cloneDeep(orgs);
            const filteredData= selectedOgranizationData[0].childScopes?.length ?
                recursiveSearch("childScopes", [selectedOgranizationData[0]], activeFilter, orgs.id) : [];
            return filteredData.length ? filteredData : [];
        } else {
            return orgs;
        }
    }, [activeFilter, orgs]);

    const onChangeEvent = (scope) => {
        setSelectedScope(scope[0]);
    }

    const disableElement = (ele) => {
       return _.toLower(ele.resourceType) === "organization" || _.toLower(ele.resourceType) === "folder";
    }

    const customStyles = {
        treeItemBase: {
            height: '55px'
        },
        treeListBase: {
            maxHeight: 'unset'
        }
    }

    return <div style={{display: "inline"}}>
        <SearchWidget color="secondary" className={serviceConnectorMenuStyles['search-widget-container']} alwaysOpen={true} placeholder={t("search")} setFilter={setActiveFilter} widgetClassName={serviceConnectorMenuStyles['search-widget']}/>
        <div className={styles["dropdown-icon"]} style={{margin: "15px 40px 0px 40px", overflowY: 'auto', height: '85%'}}>
            <TreeList
                treeData={filteredScopes}
                menuType={'singleRadio'}
                uniqueIdentifier={'id'}
                labelKey={'name'}
                bottomBorder={true}
                childKey={'childScopes'}
                selectedValues={[activeScope]}
                onChange={onChangeEvent}
                expandLevel={'max'}
                isOptionDisabled={disableElement}
                iconRenderer={IAMResourceIconRenderer}
                customStyles={customStyles}
                dropdownUpIcon={() => <DropdownArrowDownIcon
                    className={styles["tenancy-icon-color"]}/>} 
                dropdownDownIcon={() => <DropdownArrowUpIcon
                    className={styles["tenancy-icon-color"]}/>}
                    />
        </div>
    </div>
});

export default () => {
    const [isDisabled, setIsDisabled] = useState(true);
    const location = useLocation();
    const activeScope = useSelector(state => state.tenancy.selectedScope);
    const scopesFullyLoaded = useSelector(state => state.tenancy.scopesFullyLoaded);
    const selectedOrg = useSelector(state => state.tenancy.selectedOrg)
    const scope = useSelector(state => state.tenancy.selectedScope)
    const isMenuOpen = useSelector(state => state.menu.activeWidget === "scope");
    const [selectedScope, setSelectedScope] = useState(activeScope);
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);
    const isFleetManagementEnabled = useFeatureFlag("NetApp.FleetManagement/*");
    const showAllScope = SHOW_ALL_SCOPE_LOCATIONS.some(path => location.pathname.includes(path));
    const scopeName = showAllScope ? selectedOrg?.name : activeScope?.name || t("not_applicable");

    useEffect(() => {
         if (!_.isUndefined(scope)) {
            let scopeId = scope.id; 
           
            dispatch({
                type: "TENANCYV4:SET-PERMISSIONS",
                payload: {
                    scopeId
                }
            })
        }
        const currentPath = location.pathname;
        const isMenuDisabled = DISABLED_LOCATIONS.some(path => currentPath.includes(path));
        setIsDisabled(isMenuDisabled);
        // Close the menu If already open for isMenuDisabled state
        if (isMenuDisabled && isMenuOpen) {
            dispatch({ type: "MENU:CLOSE-WIDGET" });
        }

    }, [location, selectedOrg, scope]);

    const toggleHandler = (isActive) => {
        if(!isActive && !scopesFullyLoaded){
            dispatch({
                type: "TENANCYV4:FETCH-SCOPES",
                payload: {
                    loadSingleScope: false,
                }
            })
        }
    }

    return <SlidingWidget
        widgetKey="scope"
        menuTitle={isFleetManagementEnabled ? t("scopes") : t("projects")}
        triggerDisabled={isDisabled}
        canClose={() => {
            return false;
        }}
        className={styles["ncl-scope-menu"]}
        triggerClassName={styles['caption-button']}
        triggerActiveClassName={[styles['caption-button-active']]}
        onToggle={toggleHandler}
        TriggerButton={(props) => <CaptionButton isDisabled={isDisabled} title={isFleetManagementEnabled ? t("scope") : t("project")} value={scopeName} {...props}/>}
        MenuFooter={() => <ScopeMenuFooter activeScope={activeScope} selectedScope={selectedScope}/>}
    >
        {scopesFullyLoaded ? <MenuContent selectedScope={selectedScope} setSelectedScope={setSelectedScope}/> : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><InlineLoader/></div>}
    </SlidingWidget>
};